import { render } from "./LocaleSwitcher.vue?vue&type=template&id=32785ab6&scoped=true"
import script from "./LocaleSwitcher.vue?vue&type=script&lang=js"
export * from "./LocaleSwitcher.vue?vue&type=script&lang=js"

import "./LocaleSwitcher.vue?vue&type=style&index=0&id=32785ab6&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/Portal/portal-partner-cicd-staging@2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32785ab6"]])

export default __exports__